import { render, staticRenderFns } from "./BusinessAddEditView.vue?vue&type=template&id=894ea0c2&scoped=true&"
import script from "./BusinessAddEditView.vue?vue&type=script&lang=js&"
export * from "./BusinessAddEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ea0c2",
  null
  
)

export default component.exports